//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
import LogoBtn from '~/components/public/logo-btn.vue';
import { throttle, scrollbarToBrowserBottom } from '~/utils';
export default {
  components: {
    articleList: () => import('~/components/index/article-list.vue'),
    LogoBtn,
  },
  validate({ params }) {
    // eslint-disable-next-line
    return !/[\u4e00-\u9fa5]+/g.test(params.type);
  },
  async asyncData({ params, $http, error }) {
    const type = params.type; // 获取类型
    let articleResult = null;
    let timestamp = null;
    let loaded = 0;
    const vipTagIds = [
      'nuggets',
      'institution_research',
      'foresight',
      'stock_analysis',
      'vip_announcement',
      'vip_hotspot',
      'guru_selected',
      'hk_data_model',
      'as_data_model',
      'us_data_model',
      'vip_chief_reply',
      'vip_limit_up_stock_reply',
      'selected',
    ]; // 所有会员文章类型
    const [err, getChannelArticleData] = await $http(
      api.getChannelArticle({ type })
    );
    if (err) {
      error({
        statusCode: 404,
        message: {
          title: '很抱歉您访问的页面出错了！',
          desc:
            '可能原因：1、系统繁忙；2、网络链接失败；3、找不到请求页面；' +
            `4: api.getChannelArticle({${type}}) failed`,
        },
      });
    }
    articleResult = getChannelArticleData?.result ?? [];
    if (articleResult?.length > 0) {
      loaded += articleResult.length;
      timestamp = articleResult
        ? articleResult[articleResult.length - 1].data.timestamp - 1
        : null;
      articleResult = articleResult.filter(item => item.data);
    }

    return {
      articleList: articleResult,
      timestamp,
      vipTagIds,
      loaded,
    };
  },
  data() {
    return {
      timestamp: null,
      more: true,
      loadTime: 1,
      loading: false,
    };
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.hanlder);
  },
  mounted() {
    window.addEventListener('scroll', this.hanlder);
  },
  methods: {
    async getMore() {
      this.loadTime++;
      this.loading = true;
      if (this.loadTime >= 4) {
        window.removeEventListener('scroll', this.hanlder);
      }
      const type = this.$route.params.type;
      let articleResult = null;

      articleResult = await this.$axios(
        api.getChannelArticle({
          type,
          timestamp: this.timestamp,
          loaded: this.loaded,
        })
      );

      articleResult = articleResult?.result;

      if (articleResult?.length > 0) {
        this.loaded += articleResult.length;
        articleResult = articleResult.filter(item => item.data);
        // 判断是否为加载更多
        this.articleList = this.timestamp
          ? [...this.articleList, ...articleResult]
          : articleResult;
        // 赋值文章列表最后一篇的时间
        this.timestamp = articleResult
          ? articleResult[articleResult.length - 1].data.timestamp - 1
          : null;
        this.more = articleResult.length === 0 ? false : true;
        this.loading = false;
      } else {
        this.more = false;
        this.loading = false;
      }
    },
    hanlder() {
      const range = scrollbarToBrowserBottom();
      const self = this;
      if (range >= 1100 && range <= 1500 && !self.loading) {
        throttle(self.getMore(), 2000);
      }
    },
  },
};
